import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export function TestimonialsSection() {
  const testimonials = [
    {
      quote: "DomainDash made finding and registering a name for my new business an absolute breeze. The entire process took less than five minutes!",
      author: "Sarah L.",
      role: "Founder of The Bright Crate",
      avatar: "https://storage.googleapis.com/fenado-ai-farm-public/generated/dd0115f4-c0c6-4abf-9be6-d22b377e3c80.webp",
      delay: 0.1
    },
    {
      quote: "I love the clean interface and straightforward pricing. I've moved all my domains over to DomainDash and couldn't be happier.",
      author: "Mark T.",
      role: "Developer & Tech Blogger",
      avatar: "https://storage.googleapis.com/fenado-ai-farm-public/generated/438e7e57-68f7-4cbc-a05f-bbdfc71657fa.webp",
      delay: 0.2
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Join thousands of satisfied customers who trust DomainDash for their domain needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: testimonial.delay }}
              viewport={{ once: true }}
            >
              <Card className="h-full bg-card hover:shadow-md transition-all duration-300 border border-border overflow-hidden">
                <CardContent className="p-6 relative">
                  <Quote className="absolute top-6 right-6 h-8 w-8 text-primary/10" />
                  <p className="text-foreground mb-6 relative z-10">
                    "{testimonial.quote}"
                  </p>
                  <div className="flex items-center">
                    <Avatar className="h-12 w-12 mr-4 border-2 border-primary/20">
                      <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                      <AvatarFallback className="bg-primary/10 text-primary font-medium">
                        {testimonial.author.split(' ').map(n => n[0]).join('')}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <p className="font-semibold text-foreground">{testimonial.author}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}